$(document).ready(function () {
    $(document).on('change', '.plan_input', function() {
        $(this).parent().addClass('active').siblings().removeClass('active');
        var id = $(this).val();
        var subs = $('.select-delivery-time option:selected').val();
        var price = $(".variant_selector option:selected").data('price');
        var compare = $(".variant_selector option:selected").data('compare');
        var bottle = $(".variant_selector option:selected").data('id');
        var rate = $(this).data('rate');
        var template = $('.template-name').val();

        option_change(id, subs, price, compare, rate, bottle, template);

    })

    $(document).on('change', '.select-delivery-time', function() {
       var subs = $(this).val();
        $('#selling_plan').val(subs)
    })

    $(document).on('change', '.variant_selector', function() {
        var id = $('.plan_input:checked').val(); 
        var subs = $('.select-delivery-time option:selected').val();
        var price = $("option:selected", this).data('price');
        var compare = $("option:selected", this).data('compare');
        var rate = $('.plan_input:checked').data('rate');
        var bottle = $("option:selected", this).data('id');
        var template = $('.template-name').val();
       
        option_change(id, subs, price, compare, rate, bottle, template);
      
    })

  // default selected discount 
    var price_select = $(".variant_selector option:selected").data('price');
    var compare_select = $(".variant_selector option:selected").data('compare');
    var rate_select = $('.plan_input:checked').data('rate');

    if(compare_select > price_select ) {
        price_select = price_select * 0.01;
        compare_select = compare_select * 0.01;
        var save = Math.floor(compare_select - (price_select * rate_select));
        $('.fixed-discount').text('Save ' + currency + save)
    }else{
        price_select = price_select * 0.01;
        var save = Math.floor(price_select - (price_select * rate_select));
        $('.fixed-discount').text('Save ' + currency + save)
    }

  // when enable quanity bundle 
    let price = $('.quanity-input:checked').data('price');
    let compare = $('.quanity-input:checked').data('compare');
    let rate = $('.quanity-input:checked').data('rate');

    if(compare > price ) {
      price = price * 0.01;
        compare = compare * 0.01;
        var save = (compare - (price * rate)).toFixed();
        $('.fixed_discount').text('Save ' + currency + save)
    }else{
        price = price * 0.01;
        var save = (price - (price * rate)).toFixed();
        $('.fixed_discount').text('Save ' + currency + save)
    }
});



function option_change(id, subs, price, compare, rate, bottle, template) {
   
    price = (price * 0.01).toFixed(2);
    compare = (compare * 0.01).toFixed(2);

    if(bottle == 1){
        $('.gift-item').hide();
    }else if (bottle == 2){
        $('#gift-item').show();
        $('#gift-card').hide();
    }else if (bottle == 3){
        $('#gift-item').hide();
        $('#gift-card').show();
    }

    if(id == 1) {
        $('#selling_plan').val(subs);
        $('.purchase-price-save').show();
        $('.subscribe-text').addClass('show').removeClass('hide');
        $('.onetime-text').removeClass('show').addClass('hide');

        if (template == 'oil') {
            if( bottle == 1 || bottle == 7) {
                $('#save_2').text('15');
                $('#save_3').text('20');
                $('.fixed-discount').text('Save $5');
            } else if (bottle == 2 || bottle == 8) {
                $('#save_2').text('15');
                $('#save_3').text('20');
                $('.fixed-discount').text('Save $15');
            } else if (bottle == 3 || bottle == 9) {
                $('#save_2').text('15');
                $('#save_3').text('20');
                $('.fixed-discount').text('Save $40');
            } else if (bottle == 4 || bottle == 10) {
                $('.fixed-discount').text('Save $10');
            } else if (bottle == 5 || bottle == 11) {
                $('#save_2').text('15');
                $('#save_3').text('28');
                $('.fixed-discount').text('Save $27');
            } else if (bottle == 6 || bottle == 12) {
                $('#save_2').text('15');
                $('#save_3').text('28');
                $('.fixed-discount').text('Save $72'); 
            }
             
        } else {
          var saving_1 = $('.save_price_1').data('subsprice');
          var saving_2 = $('.save_price_2').data('subsprice');
          var saving_3 = $('.save_price_3').data('subsprice');
          if (saving_1 > 0 || saving_2 > 0 || saving_3 > 0) {
              $('.purchase-price-save').show();
              if(saving_1 > 0) {
                $('#save_1').parent().show();
                $('#save_1').text(saving_1);
              } else {
                $('#save_1').parent().hide();
              }
              if(saving_2 > 0) {
                $('#save_2').parent().show();
                $('#save_2').text(saving_2);
              }else{
                $('#save_2').parent().hide();
              }
              if(saving_3 > 0) {
                $('#save_3').parent().show();
                $('#save_3').text(saving_3);
              }else{
                $('#save_3').parent().hide();
              }
          }else{
            $('.purchase-price-save').hide();
          }
        }
              
        var save = 0;
        if(compare > price) { 
            $('.discount-price').text(currency + compare);
            save = Math.floor(compare - (price * rate));
            $('.fixed-discount').text('Save ' + currency + save);

        }else{
            $('.discount-price').text(currency + price);
            save = Math.floor(price - (price * rate));
            $('.fixed-discount').text('Save ' + currency + save)
        }

        

        $('.reg-price').text(currency + (price * rate).toFixed(2));
        $('.total-value').show();
        $('.onetime_price').text(currency + price);
        $('.subs_price').text(currency + (price * rate).toFixed(2));
      
   } else {
      $('.subscribe-text').addClass('hide').removeClass('show');
      $('.onetime-text').removeClass('hide').addClass('show');

      $('#selling_plan').val('');
      if (template == 'oil') {
        if( bottle == 1 || bottle == 7) {
            $('#save_2').text('5');
            $('#save_3').text('10');
        } else if (bottle == 2 || bottle == 8) {
            $('#save_2').text('5');
            $('#save_3').text('10');
        } else if (bottle == 3 || bottle == 9) {
            $('#save_2').text('5');
            $('#save_3').text('10');
        } else if (bottle == 4 || bottle == 10) {
            
        } else if (bottle == 5 || bottle == 11) {
            $('#save_2').text('5');
            $('#save_3').text('20');
        } else if (bottle == 6 || bottle == 12) {
            $('#save_2').text('5');
            $('#save_3').text('20');
        }
      } else {
        var saving_1 = $('.save_price_1').data('price');
        var saving_2 = $('.save_price_2').data('price');
        var saving_3 = $('.save_price_3').data('price');
        if (saving_1 > 0 || saving_2 > 0 || saving_3 > 0 ) {
          $('.purchase-price-save').show();
          if(saving_1 > 0) {
            $('#save_1').parent().show();
            $('#save_1').text(saving_1);
          } else {
            $('#save_1').parent().hide();
          }
          if(saving_2 > 0) {
            $('#save_2').parent().show();
            $('#save_2').text(saving_2);
          }else{
            $('#save_2').parent().hide();
          }
          if(saving_3 > 0) {
            $('#save_3').parent().show();
            $('#save_3').text(saving_3);
          }else{
            $('#save_3').parent().hide();
          }
          console.log('saving_3 ' + saving_3);
        }else{
          $('.purchase-price-save').hide();
        }
    }

    if(compare > price) {
            $('.total-value').show();
            $('.discount-price').text(currency + compare);
            $('.onetime_price').text(currency + price);
            $('.subs_price').text(currency + price);
    }else{
        $('.discount-price').text('');
        $('.total-value').hide();
        $('.onetime_price').text(currency + price );
        $('.subs_price').text(currency  + (price * rate).toFixed(2));
    }
   }
}
